import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export const constantRouterMap  = [
	{
		path: '/login',
		name: '登录页面',
		meta:{
			title: '登录'
		},
		hidden: true,
		component: resolve=>require(['@/view/home/Login'] , resolve)
	},
	{
		path: '/',
		name: 'Index',
		meta:{
			title: '控制台', icon: 'md-home', id: 1
		},
		hidden: true,
		component: resolve=>require(['@/view/home/Index'] , resolve)
	},
	{
		path: '/404',
		name: '404',
		meta:{
			title: '页面丢失啦'
		},
		hidden: true,
		component: resolve=>require(['@/view/home/404'] , resolve)
	}

];

export default new Router({
	scrollBehavior: () => ({ y: 0 }),
	mode: 'history',
	routes: constantRouterMap
})

export const asyncRouterMap = [

]



// WEBPACK FOOTER //
// ./src/router/index.js